import { render, staticRenderFns } from "./admin-setting-user-project-form.vue?vue&type=template&id=21556534"
import script from "./admin-setting-user-project-form.vue?vue&type=script&lang=js"
export * from "./admin-setting-user-project-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports